export default "__VITE_ASSET__pOcbNv8o__"